import { render, staticRenderFns } from "./Yplyzdhxphc.vue?vue&type=template&id=dc2cfd10&scoped=true&"
import script from "./Yplyzdhxphc.vue?vue&type=script&lang=js&"
export * from "./Yplyzdhxphc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2cfd10",
  null
  
)

export default component.exports